import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { RazorPayProperties, useRazorPayProperties } from "./RazorPayProperties";

import { DraftRazorPayButtonComponent } from "./DraftRazorPayButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { RazorPayButton } from "./RazorPayButton";
import { Registry } from "../../../../base/register";

export const RazorPayButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useRazorPayProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <RazorPayButton {...properties}
            className={className}>
            {children}
        </RazorPayButton>
    )
}

Registry.addControl({
    id: "f1b819d8-e1cc-46f9-9f9d-9b0ef39b1ea8",
    name: "RazorPay Button",
    type: ControlType.RazorPayButton,
    properties: RazorPayProperties,
    component: RazorPayButtonComponent,
    draftComponent: DraftRazorPayButtonComponent
})
